export const sortOptions = [
  { name: "Name: A-Z", value: "ascending" },
  { name: "Name: Z-A", value: "descending" },
  { name: "Price: Lowest", value: "lowToHigh" },
  { name: "Price: Highest", value: "highToLow" },
];
